import { render } from "./PublicActivityDetailView.vue?vue&type=template&id=0c683b83&scoped=true"
import script from "./PublicActivityDetailView.vue?vue&type=script&lang=js"
export * from "./PublicActivityDetailView.vue?vue&type=script&lang=js"

import "./PublicActivityDetailView.vue?vue&type=style&index=0&id=0c683b83&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c683b83"]])

export default __exports__